import styled from 'styled-components'

import { mainColors } from '../../styles/colors'
import { _2XS_Medium } from '../../styles/typography'

export const Month = styled.div`
  display: flex;
  flex-direction: column;
`

export const Weekdays = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 28px);
`

export const Weekday = styled.div`
  ${_2XS_Medium};
  color: ${mainColors.neutralExtraDark};
  text-align: center;
  padding-bottom: 6px;
`

export const Days = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 28px);
  row-gap: 2px;
`
